import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { EnquiryQueue } from "./EnquiryQueue";
import { Inquiries } from "./Inquiries";

/**
 * One front door for enquiries. Australian spelling, one nav entry.
 *
 * Two genuinely different streams live behind it, and both keep everything
 * they had — they were never duplicates, just two tabs wearing near-identical
 * names:
 *
 * - "From the website": TC-ENQ contact and callback submissions from the
 *   public site, promoted to a referral (prefilled, keeping the trail) or
 *   closed with a reason. Admin and manager only, like the rest of intake.
 * - "Business enquiries": the sales record — organisations asking about
 *   services, linked to companies and contacts, quoted from their services of
 *   interest, worked new → contacted → converted.
 *
 * A website enquiry that turns out to be business development is a paste away;
 * nothing automatic, because the two registers mean different things.
 */

type Stream = "website" | "business";

export const Enquiries = ({ initial }: { initial?: Stream }) => {
    const { user } = useAuth();
    // The website queue is intake, and intake is decided by admins and
    // managers; everyone else lands straight on the business register they
    // already had.
    const seesWebsite = user?.role === "admin" || user?.role === "manager";
    const [stream, setStream] = useState<Stream>(initial ?? (seesWebsite ? "website" : "business"));

    return (
        <div style={{ display: "grid", gap: "0.85rem" }}>
            {seesWebsite && (
                <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap" }}>
                    <button className={stream === "website" ? "btn" : "icon-btn"}
                        onClick={() => setStream("website")}>
                        From the website
                    </button>
                    <button className={stream === "business" ? "btn" : "icon-btn"}
                        onClick={() => setStream("business")}>
                        Business enquiries
                    </button>
                </div>
            )}
            {stream === "website" && seesWebsite ? <EnquiryQueue /> : <Inquiries />}
        </div>
    );
};
